import { Component, EventEmitter, Output } from '@angular/core';

import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { HeadingComponent } from 'src/app/shared/components/heading/heading.component';
import { UtilityService } from 'src/app/shared/services/utility.service';

export const MABLE_VERIFIED_LEARN_MORE_EXTERNAL_LINK = 'https://mable.com.au/safeguards/' as const;

@Component({
  selector: 'app-verified-worker-badge-modal',
  standalone: true,
  templateUrl: './verified-worker-badge-modal.component.html',
  styleUrls: ['./verified-worker-badge-modal.component.scss'],
  imports: [ButtonComponent, HeadingComponent],
})
export class VerifiedWorkerBadgeModalComponent {
  @Output() onDismiss = new EventEmitter<void>();

  constructor(private readonly utilityService: UtilityService) {}

  learnMore(): void {
    this.utilityService.openExternalLink(MABLE_VERIFIED_LEARN_MORE_EXTERNAL_LINK);
  }

  dismiss(): void {
    this.onDismiss.emit();
  }
}
